const customTemplateTextDirective = function () {
    return {
        scope: {
            customlangkey: '@',
        },
        restrict: 'E',
        templateUrl: 'partials/directives/dt-custom-template-text.html',
        controller: function controller($scope, langService) {
            // If the lang string is empty just return null not the fallback text.
            let string = langService.getTextWithoutFallback($scope.customlangkey);

            if (string.startsWith('base64img=data:image')) {
                // Images sent via the Printer App and ProPoint Agent have to be base64 encoded so let's only use base64
                // encoded images. In addition to support loading remote images we would need to add a small delay to
                // the PrintPrintDriver.js to allow remote images to load.
                $scope.parsedImage = string.replace('base64img=', '');
            } else if (string.startsWith('qrcode=')) {
                $scope.parsedQrCode = string.replace('qrcode=', '');
            } else {
                $scope.parsedString = string;
            }
        },
    };
};

module.exports = customTemplateTextDirective;
